module.exports = __webpack_public_path__ + "img/default-logo-dark.5c5a2f3c.png";